import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ReactiveFormsModule } from '@angular/forms'

import { ChatWindowPreviewComponent } from './chat-window-preview/chat-window-preview.component'
import { ProfileContainerComponent } from './profile-container/profile-container.component'
import { CustomMaterialModule } from '../material/custom-material.module'
import { AttributeModule } from '../attribute/attribute.module'
import { UploadModule } from '../upload/upload.module'
import { ButtonModule } from '../button/button.module'

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CustomMaterialModule,
    AttributeModule,
    UploadModule,
    ButtonModule,
  ],
  declarations: [
    ProfileContainerComponent,
    ChatWindowPreviewComponent,
  ],
  exports: [
    ProfileContainerComponent,
    ChatWindowPreviewComponent,
  ]
})
export class ProfileModule {
}



// WEBPACK FOOTER //
// ./src/app/shared/profile/profile.module.ts